var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar',{attrs:{"id":"cookiebar","fixed-bottom":true,"mobile-burger":false}},[_c('template',{slot:"start"},[_c('div',{staticStyle:{"padding":"0"},attrs:{"id":"consent-banner"}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }